import { useCallback } from 'react';

type AsyncFunction<T> = () => Promise<T>;

export function useCallbackFetchRetry<T>(
  asyncFunction: AsyncFunction<T>,
  maxRetries: number = 3,
  delayMs: number = 500
): UseAsyncRetryResult<T> {
  const execute = useCallback((...params: any) => {
    const attemptFetch = async (currentAttempt: number) => {
      try {
        const result = await asyncFunction(...params);
        return result;
      } catch (e) {
        if (currentAttempt < maxRetries) {
          setTimeout(() => attemptFetch(currentAttempt + 1), delayMs);
        } else {
          return e;
        }
      }
    };

    return attemptFetch(1);
  }, [asyncFunction, maxRetries, delayMs]);

  return execute;
}
